import React from 'react';
import './Row.scss'
import { FadeInOnScroll } from '../../Utilities/FadeInOnScroll';

const Row = ({ divClass, imageClass, children, animate }) => {
    const [ref] = FadeInOnScroll();

    return (
        <section ref={animate ? ref : null} className={`row no-gutters features-container ${divClass ? divClass : ""}`}>
            <div className="container-ac container-xxl">
                <div className="row-content">
                    {children}
                </div>
            </div>
        </section>
    );
};

export default Row;